/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuMultiSelectSearch_itemSearch = {
    readonly appliedFilters: ReadonlyArray<{
        readonly name: string | null;
        readonly localizedFilterName: string | null;
        readonly canBeDismissed: boolean | null;
        readonly values: ReadonlyArray<{
            readonly urlLabel: string | null;
            readonly linkReference: string | null;
            readonly count: number | null;
            readonly displayName: string | null;
        } | null> | null;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuTypeaheadContainer_itemSearch">;
    readonly " $refType": "SbSharedRefineMenuMultiSelectSearch_itemSearch";
};
export type SbSharedRefineMenuMultiSelectSearch_itemSearch$data = SbSharedRefineMenuMultiSelectSearch_itemSearch;
export type SbSharedRefineMenuMultiSelectSearch_itemSearch$key = {
    readonly " $data"?: SbSharedRefineMenuMultiSelectSearch_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuMultiSelectSearch_itemSearch">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuMultiSelectSearch_itemSearch",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SearchBrowseParsedParam",
      "kind": "LinkedField",
      "name": "appliedFilters",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "localizedFilterName",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "canBeDismissed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SearchBrowseParsedParamValue",
          "kind": "LinkedField",
          "name": "values",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "urlLabel",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "linkReference",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "count",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuTypeaheadContainer_itemSearch"
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
(node as any).hash = '044a6fb9d93d8e2612fe67938e8a7898';
export default node;
